import { Component, Inject, OnInit, ChangeDetectorRef } from '@angular/core';
import { FormGroup, FormControl, Validators, ValidatorFn, AbstractControl } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { JournalService } from '@journal/core/api/journal/journal.service';
import { Reference } from '@sparro/app/core/models/blog.model';

@Component({
  selector: 'app-reference-dialog',
  templateUrl: './reference-dialog.component.html',
  styleUrls: ['./reference-dialog.component.scss']
})
export class ReferenceDialogComponent implements OnInit {
  blogUUID: string;
  reference: Reference;
  view: boolean = true;
  new: boolean = true; // By default true, if section has ref, new is set to false

  publicationForm: FormGroup;
  webpageForm: FormGroup;

  constructor(
    public dialogRef: MatDialogRef<ReferenceDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private journalService: JournalService,
    private changeDetectorRef: ChangeDetectorRef
  ) {}

  ngOnInit() {
    this.initForm();
    // console.log(this.data);
    // this.new = this.data.new;
    this.blogUUID = this.data.uuid;

    if (this.data && this.data.reference) {
      this.reference = this.data.reference;
      this.new = false;
    }

    if (this.reference) {
      if (this.reference.reference_type == 'PUBLICATION') {
        this.view = false;
      } else if (this.reference.reference_type == 'WEBPAGE') {
        this.view = true;
      }
      this.setDefaultValues();
    }
  }

  initForm() {
    this.publicationForm = new FormGroup({
      title: new FormControl('', { validators: [Validators.required] }),
      author: new FormControl('', { validators: [Validators.required] }),
      publisher: new FormControl('', { validators: [Validators.required] }),
      volume: new FormControl('', {
        validators: [Validators.required, Validators.minLength(10), Validators.maxLength(13)]
      }),
      isbn: new FormControl('', Validators.compose([this.isbnValidator()]))
    });

    this.webpageForm = new FormGroup({
      title: new FormControl('', { validators: [Validators.required] }),
      url: new FormControl('', { validators: [Validators.required] })
    });
  }

  setDefaultValues() {
    if (!this.new) {
      if (this.reference && this.reference.reference_type == 'PUBLICATION') {
        this.publicationForm.controls.title.setValue(this.reference.title);
        this.publicationForm.controls.author.setValue(this.reference.author);
        this.publicationForm.controls.publisher.setValue(this.reference.publisher);
        this.publicationForm.controls.volume.setValue(this.reference.volume);
        this.publicationForm.controls.isbn.setValue(this.reference.isbn);
      } else if (this.reference && this.reference.reference_type == 'WEBPAGE') {
        this.webpageForm.controls.title.setValue(this.reference.title);
        this.webpageForm.controls.url.setValue(this.reference.url);
      }
    }
  }

  toggle() {
    if (this.view) {
      this.view = false;
    } else if (!this.view) {
      this.view = true;
    }
    this.changeDetectorRef.detectChanges();
  }

  submitPublication() {
    if (!this.publicationForm.valid) {
      return;
    }
    const data = {
      reference_type: 'PUBLICATION',
      blog: this.blogUUID,
      title: this.publicationForm.controls.title.value,
      author: this.publicationForm.controls.author.value,
      publisher: this.publicationForm.controls.publisher.value,
      volume: this.publicationForm.controls.volume.value,
      isbn: this.publicationForm.controls.isbn.value.toUpperCase()
    };
    if (this.new) {
      this.addReference(data);
    } else {
      this.updateReference(data);
    }
  }

  submitWebPage() {
    if (!this.webpageForm.valid) {
      return;
    }
    const data = {
      reference_type: 'WEBPAGE',
      blog: this.blogUUID,
      title: this.webpageForm.controls.title.value,
      url: this.webpageForm.controls.url.value
    };
    if (this.new) {
      this.addReference(data);
    } else {
      this.updateReference(data);
    }
  }

  // Validator functions
  public isbnValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } => {
      if (!control.value) {
        return null;
      }
      var isbn = control.value.replace(/ /gi, '').replace(/-/gi, '').toUpperCase();
      // to handle ISBN in 0-8044-2957-X format
      var valid = isbn.endsWith('X')
        ? isbn.length == 10
          ? /^\d+$/.test(isbn.slice(0, -1))
          : false
        : /^\d+$/.test(isbn);

      if (valid && (isbn.length == 10 || isbn.lenght == 13)) {
        return null;
      }
      return { invalidIsbn: true };
    };
  }

  addReference(data) {
    this.journalService.createReference(this.blogUUID, data).subscribe(
      response => {
        // console.log(response);
        this.dialogRef.close(response);
        this.webpageForm.reset();
        this.publicationForm.reset();
      },
      err => {
        console.log(err);
      }
    );
  }

  updateReference(data) {
    this.journalService.updateReference(this.blogUUID, this.reference.id, data).subscribe(
      response => {
        this.dialogRef.close(response);
      },
      err => {
        console.log(err);
      }
    );
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}
